import {useState} from "react";
import "../../styles/features/events/Picnic.css";
import axios from "../../utils/publicAxios";


const occasions = [
  {
    icon: "🎂",
    title: "Urodziny",
    text: "Kameralne świętowanie w plenerze, z piękną aranżacją i swobodną atmosferą.",
  },
  {
    icon: "💍",
    title: "Wieczór panieński",
    text: "Estetyczny, kobiecy piknik idealny na zdjęcia, rozmowy i celebrację przyszłej Panny Młodej.",
  },
  // {
  //   icon: "💕",
  //   title: "Zaręczyny/Randka",
  //   text: "Romantyczny setup dla dwojga — bez planowania, stresu i szukania miejsca na ostatnią chwilę.",
  // },
  {
    icon: "🍼",
    title: "Baby shower",
    text: "Delikatna, pastelowa aranżacja na spokojne spotkanie z bliskimi osobami.",
  },
  {
    icon: "👯",
    title: "Spotkanie z przyjaciółmi",
    text: "Piękny pretekst, żeby zebrać ulubione osoby i spędzić czas offline.",
  },
//   {
//     icon: "📸",
//     title: "Sesja zdjęciowa",
//     text: "Piknik jako gotowa scenografia do zdjęć, contentu lub wyjątkowej pamiątki.",
//   },
];

const options = [
  "Dekoracje i aranżacja",
  "Koc, poduszki i stoliki",
  "Kwiaty lub dekoracje sezonowe",
  "Personalizowana tabliczka",
  "Przekąski lub słodki stół",
  "Napoje bezalkoholowe",
  "Atrakcje kreatywne",
];

const moodOptions = [
  "Boho",
  "Pastelowy",
  "Elegancki",
  "Kolorowy",
  "Minimalistyczny",
  "Tematyczny (proszę podać w informacjach dodatkowych)",
  "Nie wiem — doradźcie mi",
  "Inny (proszę podać w informacjach dodatkowych)"
];

export default function PicnicsPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    occasion: "",
    date: "",
    guests: "",
    city: "",
    placePreference: "",
    mood: "",
    budget: "",
    message: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleSubmit = async (event) => {
  event.preventDefault();

  try {
    await axios.post("/api/picnic-requests", formData);

    alert("Dziękujemy! Twoje zapytanie zostało wysłane. Odezwiemy się do Ciebie tak szybko jak to możliwe.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      occasion: "",
      date: "",
      guests: "",
      city: "",
      placePreference: "",
      mood: "",
      budget: "",
      message: "",
    });
  } catch (error) {
    console.error(error);
    alert("Nie udało się wysłać zapytania. Spróbuj ponownie albo napisz do nas na contact@someet.pl.");
  }
};

  return (
    <main className="picnics-page">
      <section className="picnic-hero">
        <div className="picnic-hero__overlay" />

        <div className="picnic-hero__content">
          <span className="picnic-eyebrow">Organizacja pikników · Warszawa</span>
          <h1>Pikniki tworzone pod Twoją okazję</h1>
          <p>
            Urodziny, wieczór panieński, a może spotkanie z przyjaciółmi?<br/>
            Opowiedz nam o swoim pomyśle a my zadbamy o klimat, aranżację i każdy detal wydarzenia.
          </p>

          <div className="picnic-hero__actions">
            <a href="#picnic-request" className="picnic-btn picnic-btn--primary">
              Wyślij zapytanie
            </a>
            <a href="#how-it-works" className="picnic-btn picnic-btn--secondary">
              Jak to działa?
            </a>
          </div>
        </div>
      </section>

      <section className="picnic-section picnic-intro">
        <span className="picnic-badge">Bez gotowych pakietów · indywidualna wycena</span>
        <h2>Każdy piknik projektujemy osobno.</h2>
        <p>
          Nie musisz wybierać sztywnego pakietu. Opisz nam okazję, liczbę osób,
          preferowany styl, miejsce i dodatki, a my wrócimy z propozycją dopasowaną
          do Twojego wydarzenia.
        </p>
      </section>

      <section className="picnic-section">
        <div className="picnic-section__heading">
          <span>Na jakie okazje?</span>
          <h2>Celebracje, które wyglądają pięknie i czują się swobodnie</h2>
        </div>

        <div className="occasion-grid">
          {occasions.map((item) => (
            <article className="occasion-card" key={item.title}>
              <div className="occasion-card__icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="picnic-section picnic-options">
        <div className="picnic-options__content">
          <span className="picnic-label">Co możemy przygotować?</span>
          <h2>Od koca i dekoracji po pełną aranżację pikniku.</h2>
          <p>
            Zakres zależy od okazji, liczby osób, miejsca i budżetu. Możesz mieć
            własną wizję albo zostawić nam dobór stylu. Na życzenie możemy też
            przygotować atrakcje kreatywne, takie jak malowanie świec, kieliszków,
            płócien lub inne aktywności dopasowane do charakteru spotkania.
          </p>
        </div>

        <div className="options-list">
          {options.map((option) => (
            <div className="option-pill" key={option}>
              ✓ {option}
            </div>
          ))}
        </div>
      </section>

      <section className="picnic-section picnic-how" id="how-it-works">
        <div className="picnic-section__heading">
          <span>Jak to działa?</span>
          <h2>Prosto, lekko i bez chaosu</h2>
        </div>

        <div className="steps-grid">
          <article>
            <strong>01</strong>
            <h3>Wysyłasz zapytanie</h3>
            <p>Podajesz okazję, liczbę osób, datę, miejsce i klimat, który Ci się podoba.</p>
          </article>

          <article>
            <strong>02</strong>
            <h3>Przygotowujemy propozycję</h3>
            <p>Wracamy z pomysłem, zakresem organizacji i indywidualną wyceną.</p>
          </article>

          <article>
            <strong>03</strong>
            <h3>Tworzymy piknik</h3>
            <p>W ustalonym dniu przygotowujemy aranżację, a Ty przychodzisz i celebrujesz moment.</p>
          </article>
        </div>
      </section>

      <section className="picnic-section picnic-request" id="picnic-request">
        <div className="request-card">
          <div className="request-card__intro">
            <span className="picnic-label">Zapytanie o wycenę</span>
            <h2>Opowiedz nam o swoim pikniku</h2>
            <p>
                Wypełnij krótki formularz, a my odezwiemy się z indywidualną propozycją
                i wyceną pikniku.
            </p>
          </div>

          <form className="picnic-form" onSubmit={handleSubmit}>
            <div className="form-grid">
              <label>
                Imię *
                <input name="name" value={formData.name} onChange={handleChange} required placeholder="Np. Marta" />
              </label>

              <label>
                Email *
                <input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="twoj@email.pl" />
              </label>

              <label>
                Telefon
                <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Opcjonalnie" />
              </label>

              <label>
                Okazja*
                <select name="occasion" value={formData.occasion} required onChange={handleChange}>
                  <option value="">Wybierz okazję</option>
                  <option>Urodziny</option>
                  <option>Wieczór panieński</option>
                  <option>Baby shower</option>
                  <option>Spotkanie z przyjaciółmi</option>
                  <option>Zaręczyny/randka</option>
                  <option>Inna (proszę podać w informacjach dodatkowych)</option>
                </select>
              </label>

              <label>
                Planowana data
                <input name="date" type="date" value={formData.date} onChange={handleChange} />
              </label>

              <label>
                Liczba osób*
                <input name="guests" type="number" min="1" value={formData.guests} required onChange={handleChange} placeholder="Np. 6" />
              </label>

              <label>
                Miasto / okolica
                <input name="city" value={formData.city} onChange={handleChange} placeholder="Np. Warszawa, Mokotów" />
              </label>

              <label>
                Miejsce
                <select name="placePreference" value={formData.placePreference} onChange={handleChange}>
                  <option value="">Wybierz opcję</option>
                  <option>Mam już wybrane miejsce (proszę podać w informacjach dodatkowych)</option>
                  <option>Potrzebuję propozycji miejsca</option>
                  <option>Chcę piknik w ogrodzie / na prywatnym terenie</option>
                  <option>Nie wiem jeszcze</option>
                </select>
              </label>

              <label>
                Preferowany klimat
                <select name="mood" value={formData.mood} onChange={handleChange}>
                  <option value="">Wybierz klimat</option>
                  {moodOptions.map((mood) => (
                    <option key={mood}>{mood}</option>
                  ))}
                </select>
              </label>
            </div>

            <label className="form-message">
              Dodatkowe informacje
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                placeholder="Napisz np. jaki styl lubisz, czy mają być przekąski, kwiaty, fotograf, dekoracje, tort, gry albo inne dodatki."
              />
            </label>

            <button className="picnic-btn picnic-btn--primary picnic-form__submit" type="submit">
                Wyślij zapytanie
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}
